import { useState, useEffect } from "react";
import { Box, Button, ButtonGroup, Dialog, DialogTitle } from "@mui/material";
import axios from "axios";
import configs from "../Constants";
import EditableField from "../Components/sub_comp/EditableField";
import { IconButton } from "@mui/material";
import { TextField } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AddIcon from "@mui/icons-material/Add";
import Chip from "@mui/material/Chip";
import { useMediaQuery } from "@mui/material";
import DeleteDiaologue from "./sub_comp/Delete";
import DeleteIcon from "@mui/icons-material/Delete";
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import SwitchButton from './sub_comp/SwitchButton';

import { timezones } from './util';

import * as locale from 'locale-codes';
import {
  Edit as EditIcon,
  Check as CheckIcon,
  Close as CloseIcon,

} from "@mui/icons-material";
import CircularProgress from '@mui/material/CircularProgress';


export default function Settings() {
  const [tabValue, setTabValue] = useState(0);
  const [userInfo, setUserInfo] = useState(null);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const isMobile = useMediaQuery("(max-width:768px)");
  let userToken = sessionStorage.getItem("token") || "";
  const [dialogOPen, setDialogOPen] = useState(false);
  const [providerDetail, setProviderDetail] = useState([]);
  const [providerId, setProviderId] = useState("");
  const [provider, setProvider] = useState("");
  const [providerTitle, setProviderTitle] = useState("");
  const [providerCode, setProviderCode] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [ecomPrivateKey, setEcomPrivateKey] = useState("");
  const [clovId, setClovId] = useState("");
  const [isTest, setIsTest] = useState("");
  const [region, setRegion] = useState("");
  const [open, setOpen] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [deleteitemName, setDeleteItemName] = useState("");
  const verticals = [{ name: "Restaurant", value: "restaurant" }, { name: "Retail", value: "retail" }, { name: "Laundary", value: "laundary" }, { name: "Salon", value: "salon" }];
  const posOrdTypes = [
    { name: 'EAT IN (Self Ser.)', value: "pos_enable_ss_eat_in" },
    { name: 'TAKE AWAY (Parcel)', value: 'pos_enable_take_away' },
    { name: 'TABLE ORDER', value: 'pos_enable_dine-in' },
    { name: 'DELIVER NOW', value: 'pos_enable_delivery' },
    { name: 'CATERING/PARTY ORDER', value: 'pos_enable_catering_party' }
  ];
  const eposCatDisplayOptions = [
    { name: 'As Chips with scroll', value: 'chips_scroll' },
    { name: 'As chips with Multiline', value: 'chips_multiline' },
    { name: 'As float button', value: 'float_button' }
  ];
  const paymentMethodOptions = [
    { name: "CASH", value: "0" },
    { name: "QR/SCAN", value: "1" },
    { name: "CARD", value: "2" },
    { name: "COUPON", value: "3" },
    { name: "CREDIT", value: "4" },
  ];

  const paymentTerminals = [
    { name: 'Fygaro(Test mode)', value: "https://www.fygaro.com" },
    { name: 'Fygaro(Production mode)', value: "https://www.fygaro.com" },
    { name: 'Verifone(Test mode)', value: "https://vcloud-dev.alt-payment.com" },
    { name: 'Verifone(Production mode)', value: "https://vcloud.alt-payment.com" },
  ];
  const [pairFormOpen, setPairFormOpen] = useState(false);
  const [pairDialogOpen, setPairDialogOpen] = useState(false);

  const [registerId, setRegisterId] = useState("");
  const [terminalServiceName, setTerminalServiceName] = useState("");
  const [terminalKey, setTerminalKey] = useState("");
  const [terminalEndpoint, setTerminalEndpoint] = useState("");

  const baseURL = configs.baseURL;

  // Fetch user session data
  const userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : null;
  const userId = userData ? userData.sub : null;

  useEffect(() => {
    if (!userId) return; // Prevent API call if userId is missing

    axios
      .get(`${baseURL}/api/settings/${userId}`, {
        headers: { Authorization: `Bearer ${userToken}` },
      })
      .then((res) => {
        if (res.data?.length) {
          setUserInfo(res.data[0]);
          setLatitude(res.data[0].location.coordinates[0]);
          setLongitude(res.data[0].location.coordinates[1]);
        } else {
          // let newMerchCode = randomString(
          //   10,
          //   "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
          // );
          // handleSaveSettings(newMerchCode);
          console.log("No Settings found");
        }
      })
      .catch((error) => {
        console.log("User settings not found", error);
        // let newMerchCode = randomString(
        //    10,
        //    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
        //  );
        //  handleSaveSettings(newMerchCode);
      });
  }, []);


  useEffect(() => {
    axios.get(baseURL + "/api/thp-source?userId=" + userId, {
      headers: { Authorization: `Bearer ${userToken}` },
    }).then((res) => {
      setProviderDetail(res.data);
    });
  }, []);

  // Handle field update
  const handleFieldUpdate = (key, newValue) => {
    console.log('updating field');
    if (key === "closing_end_date" && userInfo.closing_start_date) {
      if (new Date(newValue) < new Date(userInfo.closing_start_date)) {
        toast.error("Closing end date cannot be before start date.");
        return;
      }
    }

    if (key === "closing_start_date" && userInfo.closing_end_date) {
      if (new Date(userInfo.closing_end_date) < new Date(newValue)) {
        toast.error("Closing start date cannot be after end date.");
        return;
      }
    }



    setUserInfo((prev) => ({
      ...prev,
      [key]: newValue,
    }));

    axios
      .patch(
        `${baseURL}/api/settings/${userInfo.id}`,
        { [key]: newValue },
        { headers: { Authorization: `Bearer ${userToken}` } }
      )
      .then((res) => {
        console.log("Updated response: " + res);
        toast.success("Settings updated successfully");
      })
      .catch((err) => {
        toast.error("Failed to update settings");
        console.error(err);
      });
  };

  const handleCheckboxChange = async (key) => {
    console.log('--------', key);
    const updatedValue = !userInfo[key];
    setUserInfo((prev) => ({
      ...prev,
      [key]: updatedValue,
    }));

    try {
      await axios.patch(
        `${baseURL}/api/settings/${userInfo.id}`,
        {
          [key]: updatedValue,
        },
        {
          headers: { Authorization: `Bearer ${userToken}` },
        }
      );

      toast.success(`Settings updated successfully`);
    } catch (error) {
      toast.error(`Failed to update ${key}`);
      console.error("Error updating field:", error);
    }
  };

  const handlePaymentMethodToggle = (methodValue) => {
    let currentMethods = userInfo.paymentMethods ? userInfo.paymentMethods.split(",") : [];
    if (currentMethods.includes(methodValue)) {
      currentMethods = currentMethods.filter(m => m !== methodValue);
    } else {
      currentMethods.push(methodValue);
    }
    handleFieldUpdate("paymentMethods", currentMethods.join(","));
  };

  const randomString = (length, chars) => {
    var result = "";
    for (var i = length; i > 0; --i)
      result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  }

  const handleSaveSettings = async (newMerchCode) => {
    if (!userId) return;

    try {
      await axios.post(
        `${baseURL}/api/settings`,
        {
          userId: userId,
          merchantCode: newMerchCode,
          activeProviderId: "",
          sokBGImg: "",
          activePaymentGateway: "",
          activeDeliveryPartner: "",
          currency: "INR",
          logoImg: "",
          onlyTakeAway: false,
          isLeftAlign: true,
          filterVegNonVeg: true,
          themeColor: "#f71919",
          themeTxtColor: "#fcad63",
          themePrimaryFontFam: "poppins",
          themeSecondaryFontFam: "poppins",
          customizeInWizard: true,
          dineinTax: 0,
          takeAwayTax: 5,
          notes: "",
          location: {
            type: "Point",
            coordinates: [parseFloat(latitude) || "12.2", parseFloat(longitude) || "77.0"],
          },
          openTime: 10,
          closeTime: 23,
        },
        {
          headers: { Authorization: `Bearer ${userToken}` },
        });

      console.log("Settings updated successfully!");
      toast.success(" New settings added successfully!");
      window.location.reload();
    } catch (error) {
      console.error("Error updating settings:", error);
    }
  };

  const handleClover = () => {
    let merchantDetails = {
      providerTitle: providerTitle,
      providerCode: providerCode,
      apiKey: apiKey,
      ecomPrivateKey: ecomPrivateKey,
      isTestAccount: isTest,
      region: region,
    };
    console.log(merchantDetails);
    if (clovId) {
      let data = document.getElementById("country").value;
      console.log(data);

      axios
        .put(
          baseURL + "/api/thp-source/" + clovId,
          {
            userId: userId,
            provider: provider,
            merchantDetails: JSON.stringify(merchantDetails),
          },
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        )
        .then((res) => {
          console.log(res);
          setApiKey("");
          setEcomPrivateKey("");
          setProviderCode("");
          setProviderTitle("");
          setProvider("");
          setClovId("");
          setIsTest("");
          setRegion("");

          axios
            .get(baseURL + "/api/thp-source?userId=" + userId, {
              headers: { Authorization: `Bearer ${userToken}` },
            })
            .then((res) => {
              console.log(res.data);
              setProviderDetail(res.data);
              console.log("hello");
              setOpen(false);
            });
        });
      setDialogOPen(false);
    } else if (providerCode && providerTitle) {
      axios
        .post(
          baseURL + "/api/thp-source",
          {
            userId: userId,
            provider: provider,
            merchantDetails: JSON.stringify(merchantDetails),
          },
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        )
        .then((res) => {
          console.log(res);
          setApiKey("");
          setEcomPrivateKey("");
          setProviderCode("");
          setProviderTitle("");
          setProvider("");
          setIsTest("");
          setRegion("");

          axios
            .get(baseURL + "/api/thp-source?userId=" + userId, {
              headers: { Authorization: `Bearer ${userToken}` },
            })
            .then((res) => {
              console.log(res.data);
              setProviderDetail(res.data);
              setOpen(false);
            });
        });
      setDialogOPen(false);
    } else {
      console.log("errr");
    }
  };

  const handleEdit = (cloverId) => {
    console.log(cloverId);
    let filterData = providerDetail.filter((pro) => pro.id === cloverId);
    console.log(filterData);
    setClovId(cloverId);
    setDialogOPen(true);

    let data = JSON.parse(filterData[0].merchantDetails);
    console.log(data);

    setApiKey(data.apiKey);
    setEcomPrivateKey(data.ecomPrivateKey);
    setProviderCode(data.providerCode);
    setProviderTitle(data.providerTitle);
    setProvider(filterData[0].provider);
    setIsTest(data.isTestAccount);
    setRegion(data.region);
  };

  const handleSyncMenu = (thirdParId) => {
    toast.info("Menu synce started, please wait...");
    axios.get(baseURL + "/api/clover/categories/sync/" + thirdParId, {
      headers: { Authorization: `Bearer ${userToken}` },
    });

    axios.get(baseURL + "/api/clover/products-mods/sync/" + userInfo.merchantCode, {
      headers: { Authorization: `Bearer ${userToken}` },
    });

  }

  let localeOptions = [];
  locale.all.map(loc => {
    if (loc.location && loc.tag) {
      //console.log(loc.location);
      let tag = loc.tag;
      let opt = {};
      opt[loc.tag] = loc.location + '-' + loc.tag;
      return localeOptions.push(opt);
    }
  })

  const handleDelete = (cloverId, name) => {
    setDeleteItemId(cloverId);
    setDeleteItemName(`Thirdparty account #${name}`);
    setOpenDeleteDialog(true);
  };
  const handleDeleteClose = () => {
    setOpenDeleteDialog(false);
    setDeleteItemId(null);
  };

  const handleConfirmDelete = (cloverId) => {
    setOpenDeleteDialog(false);
    setDeleteItemId(null);
    axios.delete(baseURL + "/api/thp-source/" + deleteItemId, {
      headers: { Authorization: `Bearer ${userToken}` },
    }).then((res) => {
      console.log(res);
      axios.get(baseURL + "/api/thp-source?userId=" + userId, {
        headers: { Authorization: `Bearer ${userToken}` },
      }).then((res) => {
        console.log(res.data);
        setProviderDetail(res.data);
      });
    });
  };
  const generateRegisterId = () => {
    return 'reg_' + Math.random().toString(36).substring(2, 10);
  };

  const buildVerifonePairingUrl = () => {
    const verifoneConfig = userInfo?.payTerminal?.verifone;

    if (!verifoneConfig) {
      toast.error("Verifone config missing in settings!");
      return null;
    }

    const endpoint = verifoneConfig.endpoint;
    const serviceName = verifoneConfig.serviceName;
    const apiKeyFromSettings = verifoneConfig.key;

    const merchantCode = userInfo.merchantCode;

    const regId = registerId || generateRegisterId();

    const serial = "VTT_NextOrder";

    return `${endpoint}/webint/config/${serviceName}/${apiKeyFromSettings}?register_id=${regId}&merchant_id=${merchantCode}&serial_number=${serial}`;
  };

  if (!userInfo) {
    return <p style={{ width: '100%', height: "100vh", textAlign: "center", display: "flex", justifyContent: "center" }}><CircularProgress color="secondary" /></p>;
  }

  return (
    <div>
      <div className=" settings header">
        <h4 align="start">Settings</h4>
        <Box
          sx={{
            width: "60%",
            display: "flex",
            alignItems: "center",
            justifyContent: "start"
          }}
        >
          <ButtonGroup aria-label="Basic button group">
            <Button
              variant={tabValue === 0 ? "contained" : "outlined"}
              style={{
                backgroundColor: tabValue === 0 ? "#F7C919" : "inherit",
                borderColor: "#F7C919",
                color: tabValue === 0 ? "black" : "inherit",
              }}
              onClick={() => setTabValue(0)}
            >
              Details
            </Button>
            <Button
              variant={tabValue === 1 ? "contained" : "outlined"}
              style={{
                backgroundColor: tabValue === 1 ? "#F7C919" : "inherit",
                borderColor: "#F7C919",
                color: tabValue === 1 ? "black" : "inherit",
              }}
              onClick={() => setTabValue(1)}
            >
              External Source
            </Button>
          </ButtonGroup>
        </Box>
      </div>

      {tabValue === 0 && userInfo && (
        <div
          style={{
            margin: "20px",
            display: "flex",
            flexDirection: "column",
            overflowY: "scroll",
            height: "calc(100vh - 144px)"
          }}
        >
          {/* Merchant Info */}
          <div
            style={{
              padding: "0px 16px",
              border: "1px solid #ddd",
              borderRadius: "8px",
              boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
              background: "white",
              marginBottom: "20px"
            }}
          >
            <h2
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                marginBottom: "16px",
              }}
            >
              Merchant Info
            </h2>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                gap: "16px",
                padding: "10px 20px"
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <label style={{ width: "40%", color: "#726e6e" }}>
                  Activate Provider :
                </label>
                <select
                  className="select_input"
                  value={userInfo.activeProviderId || ""}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    handleFieldUpdate("activeProviderId", selectedId)
                  }}
                >
                  <option value="">CUSTOM</option>
                  {providerDetail.map((pro) => (
                    <option key={pro.id} value={pro.id}>
                      {pro.provider}
                    </option>
                  ))}
                </select>
              </div>
              <EditableField
                label="Merchant Code"
                value={userInfo.merchantCode}
                fieldKey="merchantCode"
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
                isEditable={false}
              />
              <EditableField
                label="Biz Vertical"
                value={userInfo?.bizVertical}
                type="select"
                fieldKey={"bizVertical"}
                options={verticals}
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />

              <EditableField
                label="Logo"
                value={userInfo.logoImg}
                fieldKey="logoImg"
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />
              <EditableField
                label="Customer Note"
                value={userInfo.notes || "N/A"}
                fieldKey="notes"
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />
              <EditableField
                label="Receipt Footer Text"
                value={userInfo.receiptNotes || "N/A"}
                fieldKey="receiptNotes"
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />
              <EditableField
                label="Theme Text Color"
                value={userInfo.themeTxtColor}
                type="color"
                fieldKey="themeTxtColor"
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />
              <EditableField
                label="Theme Background"
                value={userInfo.themeColor}
                type="color"
                fieldKey="themeColor"
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />
              <EditableField
                label="Primary Font Name"
                value={userInfo.themePrimaryFontFam}
                type="text"
                fieldKey="themePrimaryFontFam"
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />
              <EditableField
                label="Secondary Font"
                value={userInfo.themeSecondaryFontFam}
                type="text"
                fieldKey="themeSecondaryFontFam"
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />
              <EditableField
                label="Locale"
                value={userInfo.locale}
                type="select"
                fieldKey={"locale"}
                options={localeOptions}
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />
              <EditableField
                label="Timezone"
                value={userInfo.timezone}
                type="select"
                fieldKey={"timezone"}
                options={timezones}
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />
            </div>
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: "20px", marginBottom: "20px" }}
              onClick={() => {
                setTerminalEndpoint(paymentTerminals[0].value);
                setTerminalServiceName(userInfo?.payTerminal?.verifone?.serviceName || "NextOrder");
                setTerminalKey(userInfo?.payTerminal?.verifone?.key || "4dd84130-5982-4303-aa9f-3824f80c37cf");
                setPairFormOpen(true);
              }}
            >
              Pair Payment Terminal
            </Button>
            <Dialog open={pairFormOpen} onClose={() => setPairFormOpen(false)}>
              <div style={{ padding: "20px", minWidth: "300px" }}>
                <h3>Pair Payment Terminal</h3>
                <select
                  id="pay_term_select"
                  style={{ padding: "10px", marginBottom: "20px" }}
                  value={terminalEndpoint}
                  onChange={(e) => setTerminalEndpoint(e.target.value)}
                >
                  {
                    paymentTerminals.map(pt => <option key={pt.name} value={pt.value}>{pt.name}</option>)
                  }
                </select>
                <TextField
                  fullWidth
                  label="Service name"
                  value={terminalServiceName}
                  onChange={(e) => setTerminalServiceName(e.target.value)}
                  style={{ marginBottom: "10px" }}
                />

                <TextField
                  fullWidth
                  label="Key"
                  value={terminalKey}
                  onChange={(e) => setTerminalKey(e.target.value)}
                  style={{ marginBottom: "10px" }}
                />
                <Button
                  variant="outlined"
                  onClick={() => {
                    handleFieldUpdate("payTerminal", {
                      verifone: {
                        endpoint: terminalEndpoint,
                        serviceName: terminalServiceName,
                        key: terminalKey
                      }
                    });
                    setPairDialogOpen({
                      endpoint: terminalEndpoint,
                      serviceName: terminalServiceName,
                      key: terminalKey
                    });
                    setPairFormOpen(false);
                  }}

                >
                  Continue
                </Button>
              </div>
            </Dialog>
            <Dialog open={pairDialogOpen} onClose={() => setPairDialogOpen(false)} maxWidth="lg">
              <div style={{ width: "500px", height: "500px" }}>
                <iframe
                  src={pairDialogOpen?.endpoint + '/webint/config/' + pairDialogOpen.serviceName + '/' + pairDialogOpen?.key + '?register_id=' + userInfo?.firstName + '&merchant_id=' + userInfo?.merchantCode + '&merchant_name=' + userInfo?.firstName} frameborder="0" allowtransparency="true"
                  style={{ width: "100%", height: "100%" }}
                  frameBorder="0"
                ></iframe>
              </div>
            </Dialog>

          </div>

          {/* Common Info */}
          <div
            style={{
              padding: "0px 16px",
              border: "1px solid #ddd",
              borderRadius: "8px",
              boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
              background: "white",
              marginBottom: "20px"
            }}
          >
            <h2
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                marginBottom: "16px",
              }}
            >
              Common Settings
            </h2>
            <div className={'setting-row'}>
              <SwitchButton userInfo={userInfo} keyName={'filterVegNonVeg'} label={'Veg/Non-Veg Filter'} onChange={(prp) => handleCheckboxChange(prp)} />
              <SwitchButton userInfo={userInfo} keyName={'onlyTakeAway'} label={'Only Take Away(Parcel)'} onChange={(prp) => handleCheckboxChange(prp)} />
              <SwitchButton userInfo={userInfo} keyName={'customizeInWizard'} label={'Cart-Item Customize in Wizard'} onChange={(prp) => handleCheckboxChange(prp)} />
              <SwitchButton userInfo={userInfo} keyName={'isCashOut'} label={'Allow Cash-Out?'} onChange={(prp) => handleCheckboxChange(prp)} />
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                gap: "16px",
                marginTop: "16px",
                padding: "10px 20px",
                marginBottom: "10px"
              }}
            >
              <EditableField
                label="Category Display"
                value={userInfo.eposCategoryDisplay || 'chips_scroll'}
                type="select"
                fieldKey={"eposCategoryDisplay"}
                options={eposCatDisplayOptions}
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />
              <SwitchButton
                userInfo={userInfo}
                keyName={'show_category_images'}
                label={'Show PoS Category Images'}
                onChange={(prp) => handleCheckboxChange(prp)}
              />
              <SwitchButton
                userInfo={userInfo}
                keyName={'show_customer_display'}
                label={'Show Customer Display'}
                onChange={(prp) => handleCheckboxChange(prp)}
              />
              <EditableField
                label="Default Tax (%)"
                value={userInfo.takeAwayTax}
                type="number"
                fieldKey="takeAwayTax"
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />

              <EditableField
                label="Dine-In Tax (%)"
                value={userInfo.dineinTax}
                type="number"
                fieldKey="dineinTax"
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />

              <EditableField
                label="Service Charge (%)"
                value={userInfo.dining_service_charge}
                type="number"
                fieldKey="dining_service_charge"
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />

              <EditableField
                label="Latitude"
                value={userInfo?.location?.coordinates?.[0] ?? ""}
                type="number"
                fieldKey="latitude"
                userInfo={userInfo}
                setUserInfo={setUserInfo}
              />

              <EditableField
                label="Longitude"
                value={userInfo?.location?.coordinates?.[1] ?? ""}
                type="number"
                fieldKey="longitude"
                userInfo={userInfo}
                setUserInfo={setUserInfo}
              />

              <EditableField
                label="Open Time"
                value={userInfo.openTime}
                type="number"
                fieldKey="openTime"
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />
              <EditableField
                label="Close Time"
                value={userInfo.closeTime}
                type="number"
                fieldKey="closeTime"
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />

              <EditableField
                label="Closing Start Date"
                value={userInfo.closing_start_date?.split("T")[0] || ""}
                type="date"
                fieldKey="closing_start_date"
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />

              <EditableField
                label="Closing End Date"
                value={userInfo.closing_end_date?.split("T")[0] || ""}
                type="date"
                fieldKey="closing_end_date"
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />

              <EditableField
                label="Closing Reason"
                value={userInfo.closing_remark || ""}
                type="text"
                fieldKey="closing_remark"
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />
            </div>
          </div>

          {/* POS  Settings */}
          <div className={'setting-card'}>
            <h2>Point of Sale (POS)</h2>
            <span>Order Options</span>
            <div className={'setting-row'}>
              <SwitchButton userInfo={userInfo} keyName={'pos_enable_ss_eat_in'} label={'EAT IN (Self Ser.)'} onChange={(prp) => handleCheckboxChange(prp)} />
              <SwitchButton userInfo={userInfo} keyName={'pos_enable_take_away'} label={'TAKE AWAY (Parcel)'} onChange={(prp) => handleCheckboxChange(prp)} />
              <SwitchButton userInfo={userInfo} keyName={'pos_enable_dineIn'} label={'TABLE ORDER'} onChange={(prp) => handleCheckboxChange(prp)} />
              <SwitchButton userInfo={userInfo} keyName={'pos_enable_delivery'} label={'DELIVER NOW'} onChange={(prp) => handleCheckboxChange(prp)} />
              <SwitchButton userInfo={userInfo} keyName={'pos_enable_catering_party'} label={'CATERING/PARTY ORDER'} onChange={(prp) => handleCheckboxChange(prp)} />
            </div>
            <span>Payment Method Options</span>
            <div className={'setting-row'} style={{ borderTop: "1px solid #ccc", padding: "10px" }}>
              {paymentMethodOptions.map((pm) => (
                <SwitchButton
                  key={pm.value}
                  label={pm.name}
                  userInfo={{ [pm.value]: userInfo.paymentMethods?.split(",").includes(pm.value) }}
                  keyName={pm.value}
                  onChange={() => handlePaymentMethodToggle(pm.value)}
                />
              ))}
            </div>
            <span>Default POS Options</span>
            <div className={'setting-row'} style={{ borderTop: "1px solid #ccc", paddingTop: "10px" }}>
              <SwitchButton userInfo={userInfo} keyName={'isLeftAlign'} label={'CartView Left Align'} onChange={(prp) => handleCheckboxChange(prp)} />
              <EditableField
                label="Default Order Type Selection"
                value={userInfo.defaultOrderType}
                type="select"
                fieldKey={"defaultOrderType"}
                options={posOrdTypes}
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />
              <EditableField
                label="Default Payment Method"
                value={paymentMethodOptions.find(pm => pm.value == userInfo.defaultPaymentMethodPos)?.name || 'CASH'}
                type="select"
                fieldKey={"defaultPaymentMethodPos"}
                options={paymentMethodOptions}
                userInfo={userInfo}
                setUserInfo={setUserInfo}
                onUpdate={handleFieldUpdate}
              />
            </div>

          </div>

          {/* SOK  Settings */}
          <div className={'setting-card'}>
            <h2>Self Order/Service (QSR)</h2>
            <span>Kiosk Options</span>
            <div className={'setting-row'}>

              <SwitchButton userInfo={userInfo} keyName={'Kiosk_isOfflineQR_Pay'} label={'Allow Offline App Pay (UPI etc.)'} onChange={(prp) => handleCheckboxChange(prp)} />
              <SwitchButton userInfo={userInfo} keyName={'Kiosk_isPaC_Pay'} label={'Allow Pay At Counter'} onChange={(prp) => handleCheckboxChange(prp)} />
            </div>
            <span>QR Scan Options</span>
            <div className={'setting-row'} style={{ borderTop: "1px solid #ccc" }}>

              <SwitchButton userInfo={userInfo} keyName={'SOK_Scan_isPaC_Pay'} label={'Scaned Allow Cash on Delivery'} onChange={(prp) => handleCheckboxChange(prp)} />
              <SwitchButton userInfo={userInfo} keyName={'SOK_Scan_isOfflineQR_Pay'} label={'Allow Offline App Pay(UPI etc.)'} onChange={(prp) => handleCheckboxChange(prp)} />
              <SwitchButton userInfo={userInfo} keyName={'SOK_Scan_isGateway_pay'} label={'Allow Online Pay (via Gateway like Stripe, PayU etc.)'} onChange={(prp) => handleCheckboxChange(prp)} />
            </div>
          </div>

          {/* TTO  Settings */}
          <div className={'setting-card'}>
            <h3>Table Top Orders (TTO)</h3>
            <div className={'setting-row'}>
              <SwitchButton userInfo={userInfo} keyName={'TTO_show_games'} label={'Show Games'} onChange={(prp) => handleCheckboxChange(prp)} />
              <SwitchButton userInfo={userInfo} keyName={'TTO_cat_only_floatbtn'} label={'Category Float Button'} onChange={(prp) => handleCheckboxChange(prp)} />
            </div>
          </div>

          {/* Online Order  Settings */}
          <div className={'setting-card'}>
            <h3>Online Order</h3>
            <span>Order Options </span>
            <div className={'setting-row'}>
              <SwitchButton userInfo={userInfo} keyName={'OO_isDelivery'} label={'Allow Delivery'} onChange={(prp) => handleCheckboxChange(prp)} />
              <SwitchButton userInfo={userInfo} keyName={'OO_isPickUp'} label={'Allow Pickup'} onChange={(prp) => handleCheckboxChange(prp)} />
              <SwitchButton userInfo={userInfo} keyName={'OO_isScheduledDelivery'} label={'Allow Schedule Delivery'} onChange={(prp) => handleCheckboxChange(prp)} />

            </div>
            <span>Pay Options </span>
            <div className={'setting-row'} style={{ borderTop: "1px solid #ccc" }}>
              <SwitchButton userInfo={userInfo} keyName={'OO_isCoD_Pay'} label={'Allow Cash on Delivery'} onChange={(prp) => handleCheckboxChange(prp)} />
              <SwitchButton userInfo={userInfo} keyName={'OO_isOfflineQR_Pay'} label={'Allow Offline App Pay(UPI etc.)'} onChange={(prp) => handleCheckboxChange(prp)} />
              <SwitchButton userInfo={userInfo} keyName={'OO_isGateway_pay'} label={'Allow Online Pay (via Gateway like Stripe, PayU etc.)'} onChange={(prp) => handleCheckboxChange(prp)} />

            </div>
          </div>

        </div>
      )}

      {tabValue === 1 && (
        <div style={{ padding: "20px" }}>
          <div style={{ display: "flex", justifyContent: "end" }}>
            <button className="add_btn" onClick={() => setDialogOPen(true)}>
              <AddIcon /> Add New
            </button>
          </div>
          <Dialog open={dialogOPen} maxWidth="lg" fullWidth={true}>
            <DialogTitle style={{ textAlign: "center", fontWeight: "bold" }}>
              {"Add/Edit Provider"}
            </DialogTitle>
            <div
              style={{
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
              }}
              className={"rowinput"}
            >
              <span style={{ marginBottom: "10px" }}>
                <lable style={{ width: "auto!important" }}>PoS Provider *</lable>
                <select
                  name="provider"
                  id="provider"
                  className="select_input"
                  defaultValue={provider}
                  placeholder="Select Provider"
                  onChange={(e) => setRegion(e.target.value)}
                >
                  <option value="" disabled selected hidden>
                    Select PoS Provider
                  </option>
                  <option value="Clover">CLOVER</option>
                  <option value="Square">SQUARE</option>
                  <option value="Toast">TOAST</option>

                </select>
              </span>
              <span style={{ marginBottom: "10px" }}>
                <lable style={{ width: "100%!important" }}>Merchant Name/Address *</lable>
                <input
                  className="input_cls"
                  placeholder="Enter Merchant Name/Address"
                  defaultValue={providerTitle}
                  onChange={(e) => setProviderTitle(e.target.value)}
                />
              </span>
              <span style={{ marginBottom: "10px" }}>
                <lable style={{ width: "100%!important" }}>Merchant Code *</lable>
                <input
                  className="input_cls"
                  placeholder="Enter Provider code"
                  defaultValue={providerCode}
                  onChange={(e) => setProviderCode(e.target.value)}
                />
              </span>
              <br />
              <span style={{ marginBottom: "10px" }}>
                <lable style={{ width: "100%!important" }}>Api Key *</lable>
                <input
                  className="input_cls"
                  placeholder="Enter api key"
                  defaultValue={apiKey}
                  onChange={(e) => setApiKey(e.target.value)}
                />
              </span>
              <br />
              <span style={{ marginBottom: "10px" }}>
                <lable style={{ width: "100%!important" }}>E-Com Private Key *</lable>
                <input
                  className="input_cls"
                  placeholder="Enter ecom private key"
                  defaultValue={ecomPrivateKey}
                  onChange={(e) => setEcomPrivateKey(e.target.value)}
                />
              </span>
              <span style={{ marginBottom: "10px" }}>
                <label>Is this Sandbox Account? :</label>
                <input
                  type="checkbox"
                  defaultValue={isTest}
                  onChange={(e) => setIsTest(e.target.checked)}
                />
              </span>

              <br />
              <span style={{ marginBottom: "10px" }}>
                <label for="country">Merchant Region :</label>

                <select
                  name="country"
                  id="country"
                  className="select_input"
                  defaultValue={region}
                  placeholder="Select Country"
                  style={{ marginBottom: "10px" }}
                  onChange={(e) => setRegion(e.target.value)}
                >
                  <option value="" disabled selected hidden>
                    Select Country
                  </option>
                  <option value="usa">USA</option>
                  <option value="india">India</option>
                  <option value="uae">UAE</option>
                  <option value="australia">Australia</option>
                </select>
              </span>

              <div
                style={{
                  width: "100%",
                  alignItems: "center",
                  marginTop: "20px",
                  textAlign: "right",
                }}
              >
                <Button
                  variant="outlined"
                  color="error"
                  style={{ marginRight: "20px" }}
                  onClick={() => setDialogOPen(false)}
                >
                  Close
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleClover}
                >
                  Save
                </Button>
              </div>
            </div>
          </Dialog>

          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "8px",
              marginTop: "10px",
            }}
          >
            <table
              align="center"
              cellPadding="5px"
              style={{ padding: "10px", width: "100%" }}
            >
              <thead style={{ background: "#f1f1f1" }}>
                <tr>
                  <th>#</th>
                  <th>Provider</th>
                  <th>Merchant Name</th>
                  <th>Merchant Code</th>
                  <th>API Key</th>
                  <th>E-com Private Key</th>
                  <th>Test Account?</th>
                  <th>Region</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {providerDetail.map((pro, i) => {
                  let detail = JSON.parse(pro.merchantDetails);
                  return (
                    <tr>
                      <td>{i + 1}</td>
                      <td>{pro.provider}</td>
                      <td>{detail.providerTitle}</td>
                      <td>{detail.providerCode}</td>
                      <td>{detail.apiKey}</td>
                      <td>{detail.ecomPrivateKey}</td>
                      <td>{detail.isTestAccount ? "Yes" : "No"}</td>
                      <td>{detail.region}</td>
                      <td>
                        <IconButton
                          onClick={() => handleDelete(pro.id, detail.providerTitle)}
                          aria-label="delete"
                          color="error"
                        >
                          <DeleteIcon />
                        </IconButton>
                        <IconButton
                          onClick={() => handleEdit(pro.id)}
                          aria-label="edit"
                          color="primary"
                        >
                          <EditIcon />
                        </IconButton>

                        <IconButton
                          onClick={() => handleSyncMenu(pro.id)}
                          aria-label="sync from provider"
                          color="primary"
                        >
                          <SyncAltIcon />
                        </IconButton>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {openDeleteDialog ? (
        <DeleteDiaologue
          open={openDeleteDialog}
          onClose={handleDeleteClose}
          onConfirm={handleConfirmDelete}
          itemName={deleteitemName}
          msg="delete"
        />
      ) : (
        <div />
      )}
      <ToastContainer />
    </div>
  );
}
